import React from 'react';
import { IssueCommentDto } from 'src/api/FiretrolApiClient';
import {
  useDeleteMeetingComment,
  useUpdateMeetingComment,
} from 'src/api/queries/meetings/useMeetingCommentMutations';
import { useAuth } from 'src/hooks/useAuth';
import { CommentInput } from 'src/design/molecules/CommentInput';

interface CommentValueProps {
  comment: IssueCommentDto;
}

export const CommentValue: React.FC<CommentValueProps> = ({ comment }) => {
  const { user } = useAuth();
  const scope = {
    jobId: comment.jobId!,
    meetingId: comment.meetingId!,
    topicId: comment.topicId!,
    issueId: comment.issueId!,
  };
  const updateComment = useUpdateMeetingComment(scope);
  const deleteComment = useDeleteMeetingComment(scope);

  // CommentInput only leaves edit mode when its save resolves, so a failed
  // save has to reject rather than swallow the error.
  const handleUpdate = async (newComment: IssueCommentDto) => {
    await updateComment.mutateAsync({
      commentId: comment.id,
      comment: newComment.comment,
    });
  };

  const handleDelete = async () => {
    await deleteComment.mutateAsync(comment.id);
  };

  return (
    <CommentInput
      comment={comment}
      onCommentUpdate={handleUpdate}
      onCommentDelete={handleDelete}
      currentUserId={user?.id}
    />
  );
};
